import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DisplayUserEmail } from '@nusign/picflow-backend-types';
import { StateService } from '../../../services/state.service';
import { AvatarComponent } from '../../../shared/components/avatar/avatar.component';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { ProfilePreviewComponent } from '../profile-preview/profile-preview.component';

@Component({
  selector: 'app-mention',
  imports: [AvatarComponent, ContextMenuComponent, ProfilePreviewComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './mention.component.html',
  styleUrl: './mention.component.scss',
})
export class MentionComponent {
  private state = inject(StateService);
  user = input<DisplayUserEmail>();
  userIsDeleted = input<boolean>();
  isTeamMember = !!this.state.activeTenant$?.value;
}
